import { faUndo } from "@fortawesome/pro-regular-svg-icons/faUndo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Typography } from '@mui/material';
import * as api from "api/Knowledge";
import MuiBox from 'components/MuiExtras/MuiBox';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiLink from 'components/MuiExtras/MuiLink';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { WordItemDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from "react-i18next";
import { SearchBoxPlayer } from "views/Publication/Components/RenderVideo/RenderVideoCommon";
import { FanIndicator } from "components/CallServer";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface ISearchBoxProps {
    entityId: string;
    querySearch: string;
    player: SearchBoxPlayer;
}

interface SearchBoxState {
    data: WordItemDto[];
    currentWordClick: string;
    currentWordIndex: number;
    loading: boolean;
}

type SearchBoxProps = ISearchBoxProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

abstract class SearchBox extends React.PureComponent<SearchBoxProps, SearchBoxState> {
    constructor(props: SearchBoxProps) {
        super(props);
        this.state = { data: null, currentWordClick: null, currentWordIndex: null, loading: false };
    }
    abstract loadSubtitle(): void;

    private handleClick(v: WordItemDto) {
        let { currentWordIndex, currentWordClick } = this.state;
        if (currentWordClick == null || v.word != currentWordClick) {
            currentWordClick = v.word;
            currentWordIndex = 0;
        }
        else if (v.word == currentWordClick) {
            if (currentWordIndex < v.indexes.length - 1)
                currentWordIndex++;
            else
                currentWordIndex = 0;
        }
        // Posiciona
        this.props.player.seek(Math.ceil(v.indexes[currentWordIndex]));
        this.props.player.play();

        // Finaliza
        this.setState({ currentWordClick, currentWordIndex });
    }

    private handleTimeback() {
        var player = this.props.player;
        var target = Math.max(player.getCurrentTime() - 10, 0);
        if (target >= 0 && !player.seeking()) {
            player.seek(target);
        }
    }
    private renderLine() {
        const { data, currentWordClick } = this.state;
        return data.map((v, index) => {
            return v.indexes.length == 0
                ? (
                    <MuiColor key={index} variant="muted">
                        <span>{v.word}</span><span>&nbsp;</span>
                    </MuiColor>
                )
                : (
                    <MuiColor key={index} variant={currentWordClick == v.word ? "warning" : "info"}>
                        <a
                            href="#"
                            title={this.props.t("Views.Publication.Components.RenderVideo.QssIndexCount", { count: v.indexes.length })}
                            onClick={(e) => { e.preventDefault(); this.handleClick(v); }}
                        >
                            <strong>{v.word}</strong>
                            <span> ({v.indexes.length}x)</span>
                        </a>
                        <span>&nbsp;</span>
                    </MuiColor>
                );
        });
    }
    public componentDidMount() {
        this.loadSubtitle();
    }
    public render() {
        if (this.state.loading)
            return <FanIndicator />;
        if (this.state.data == null)
            return null;
        if (this.state.data.every(p => p.indexes.length == 0)) {
            return null;
        }
        return (<MuiContainer>
            <MuiBox variant="warning" border>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Typography variant="button">{this.props.t("Views.Publication.Components.RenderVideo.FoundQssText")}</Typography>
                    </Grid>
                    {this.state.currentWordClick &&
                        <Grid item>
                            <MuiLink color="secondary" onClick={() => this.handleTimeback()}><span><FontAwesomeIcon icon={faUndo} fixedWidth={true} />10s</span></MuiLink>
                        </Grid>}
                </Grid>
                {this.renderLine()}
            </MuiBox>
        </MuiContainer>);
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class VideoSearchBoxComponent extends SearchBox {
    loadSubtitle() {
        this.setState({ loading: true });
        api.matchQuerySearchWithFileSubtitles(this.props.entityId, this.props.querySearch)
            .then((result) => {
                this.setState({ data: result, loading: false });
            });
    }
}

export const VideoSearchBox = withTranslation()(VideoSearchBoxComponent);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class YoutubeSearchBoxComponent extends SearchBox {
    loadSubtitle() {
        this.setState({ loading: true });
        api.matchQuerySearchWithMetadataSubtitles(this.props.entityId, this.props.querySearch)
            .then((result) => {
                this.setState({ data: result, loading: false });
            });
    }
}

export const YoutubeSearchBox = withTranslation()(YoutubeSearchBoxComponent);